"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _colors = require("HubStyleTokens/colors");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _AutoSaveStatus = require("playbooks-modal/constants/AutoSaveStatus");

var _default = _react.default.createClass({
  displayName: "SaveStatus",
  propTypes: {
    className: _react.PropTypes.string,
    status: _react.PropTypes.oneOf([_AutoSaveStatus.UNINITIALIZED, _AutoSaveStatus.PENDING, _AutoSaveStatus.SUCCEEDED, _AutoSaveStatus.FAILED])
  },
  renderFailedStatus: function renderFailedStatus() {
    return _react.default.createElement("span", null, _react.default.createElement(_UIIcon.default, {
      className: "m-right-1",
      color: _colors.LORAX,
      name: "remove",
      size: "small"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.saveStatus.error"
    }));
  },
  renderPendingStatus: function renderPendingStatus() {
    return _react.default.createElement(_UIFlex.default, {
      align: "center"
    }, _react.default.createElement(_UILoadingSpinner.default, {
      className: "m-right-1",
      size: "extra-small",
      use: "success"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.saveStatus.saving"
    }));
  },
  renderSucceededStatus: function renderSucceededStatus() {
    return _react.default.createElement(_UITooltip.default, {
      placement: "bottom"
    }, _react.default.createElement("span", null, _react.default.createElement(_UIIcon.default, {
      className: "m-right-2",
      color: _colors.OZ,
      name: "success",
      size: 16
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.saveStatus.saved"
    })));
  },
  renderStatus: function renderStatus(status) {
    switch (status) {
      case _AutoSaveStatus.PENDING:
        return this.renderPendingStatus();

      case _AutoSaveStatus.SUCCEEDED:
        return this.renderSucceededStatus();

      case _AutoSaveStatus.FAILED:
        return this.renderFailedStatus();

      default:
        return null;
    }
  },
  render: function render() {
    var status = this.props.status;
    return _react.default.createElement("span", {
      className: (0, _classNames.default)('save-status', this.props.className)
    }, this.renderStatus(status));
  }
});

exports.default = _default;
module.exports = exports.default;